module.exports = __webpack_public_path__ + "static/media/cook_the_vibe.bb70ce41.jpg";